<template>
    <PdfLightbox :url="data.url" />
</template>

<script>
import { AppRoot } from "@/mixins/AppRoot";
import PdfLightbox from "@/components/common/lightbox/PdfLightbox.vue";

export default {
    extends: AppRoot,
    props: {
      data: Object
    },
    components: {
        PdfLightbox,
    },
};
</script>

<style scoped></style>
